<template>
    <div
        v-if="required || error"
        :class="{error}"
        class="validationMessage"
    >
        <div class="inner">
            <svg v-if="error" svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h0"/></svg>
            <span class="text">
                {{ messageText }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: null,
        },
    },
    computed: {
        messageText() {
            if (this.error) {
                return this.message ? this.message : 'Detta fält är inte ifyllt korrekt.';
            }

            if (this.required) {
                return 'Detta fält är obligatoriskt.';
            }

            return false;
        },
    },
};
</script>

<style lang="postcss" scoped>
.validationMessage {
    margin-top: 6px;
}
.error {
    color: var(--danger);
}
.inner {
    display: flex;
    align-items: center;
}
.text {
    font-size: 13px;
}
.icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
</style>
